import Player from "@vimeo/player";
jQuery(document).ready(function () {
    var $videoSection = jQuery('.wm-videoSection');
    var $iframe = jQuery('.wm-videoSection iframe');
    var $play = jQuery('.wm-videoSection__play');
    if ($iframe.length === 0)
        return;
    var player;
    jQuery($play).click(function () {
        if (!$iframe.hasClass('-loaded')) {
            $iframe.addClass('-loaded');
            $iframe.attr('src', $iframe.attr('data-src'));
            player = new Player($iframe);
        }
        $videoSection.toggleClass('-play');
        if ($videoSection.hasClass('-play')) {
            player.play();
        }
        else {
            player.pause();
        }
    });
});
